// removed by extract-text-webpack-plugin
module.exports = {"banner":"styles__banner___3ihi_","bannerSubTitle":"styles__bannerSubTitle___KrLpI","containerCards":"styles__containerCards___2m10n","titleCard":"styles__titleCard___1UVAM","sectionBenefits":"styles__sectionBenefits___1XRhN","titleItem":"styles__titleItem___1AFWT","buttonClasses":"styles__buttonClasses___28zY6","legalText":"styles__legalText___3RwOD","cardTicket":"styles__cardTicket___FW_bV","cardNoTicket":"styles__cardNoTicket___2vTBb","containerTickets":"styles__containerTickets___2Q8iu","containerProfits":"styles__containerProfits___2_Xpz"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/AlgarForever/styles.css
// module id = 274
// module chunks = 0